import { useQuery } from '@tanstack/react-query';

import { getDynamicConfigurations } from '~/services/AccommodationService';

export const accommodationDynamicConfigurationsQueryKeys = {
  all: ['accommodation', 'dynamicConfigurations'] as const,
  detail: () => [...accommodationDynamicConfigurationsQueryKeys.all, 'detail'] as const,
};

export default function useGetDynamicConfigurations() {
  return useQuery({
    queryKey: accommodationDynamicConfigurationsQueryKeys.detail(),
    queryFn: async ({ signal }) => {
      const response = await getDynamicConfigurations({ signal });
      return response.result;
    },
  });
}
